import { Box, Container, Grid, List, ListItem, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { LoadingComponent } from '../../components'
import { loggedInUser, mediaInput } from '../../constants/helpers'
import { vdrFavoriteAction, vdrCompanyAction, vdrHomeAction, vdrMediaAction, vdrMediaGroupAction } from '../../redux/actions/VdrAction'
import { companyMasterAction } from '../../redux/actions/userAction';
import { CustomCarousel, SingleCompanyGrid, SingleVideoGrid } from '../components'


import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import MediaModel from '../../components/SingleCompanyContainer/MediaSection/MediaModel'

const VideosPage = () => {
  const { data, loading, error } = useSelector(state => state.vdrFavoriteReducer);
  

  const dispatch = useDispatch();
  const { data: vdrMediaData, loading: vdrMediaLoading } = useSelector((state) => state.vdrMediaReducer);
  const { data: companyMasterData, loading: companyMasterLoading } = useSelector((state) => state.companyMasterData);
  const { data: vdrMediaGroupData, loading: vdrMediaGroupLoading } = useSelector((state) => state.vdrMediaGroupReducer);



  const [VideosArr, setVideosArr] = useState([]);
  const [PinnedVideoArr, setPinnedVideoArr] = useState([]);
  const [CompanyVideosArr, setCompanyVideosArr] = useState([]);

  const [VideoIds, setVideoIds] = React.useState([]);


  const [CompanyMasterArr, setCompanyMasterArr] = useState([]);
  useEffect(() => {

    if (vdrMediaLoading) {
      var videoParams = {
        "userid": 1,
        "videoCode": "",
        "videoId": "",
        "videoType": "",
        "videoTitle": "", 
        "videoDescription": "",
        "isPinned":true,
        "groupId":"", 
        "group_name":"",
        "DocumentType": "Common",
        "isFeatured": true,
        "inputType": 2
      }
      dispatch(vdrMediaAction(mediaInput));
    }

    if (!vdrMediaLoading) {
      let pinnedD = vdrMediaData.Data.filter((items) => { if (items.isPinned === true && items.DocumentType === "Common" && items.groupId != "" ) return items });
          pinnedD = pinnedD.sort((a,b)=>{
            return a.item_order - b.item_order
          })

      // console.log();
      setPinnedVideoArr(pinnedD);

      setVideoIds(pinnedD.map((item) => item.videoId));

      setVideosArr(vdrMediaData.Data.filter((items) => { if (items.DocumentType === "Common") return items }));
      setCompanyVideosArr(vdrMediaData.Data.filter((items) => { if (items.DocumentType !== "Common") return items }));
    }
  }, [dispatch, vdrMediaLoading])
  useEffect(() => {
    
    if(companyMasterLoading){
      dispatch(companyMasterAction());
    }
    if(!companyMasterLoading){
      setCompanyMasterArr(companyMasterData)
    }
  }, [dispatch, companyMasterLoading])
  

  
  const [VideoGroupData, setVideoGroupData] = React.useState([]);


  useEffect(() => {
      if (vdrMediaGroupLoading) {
          var videoParams = {
              "status": 1,
              "inputType": 3
          }
          dispatch(vdrMediaGroupAction(videoParams));
      }
      if (!vdrMediaGroupLoading) {
          setVideoGroupData(vdrMediaGroupData.Data)
      }
  }, [dispatch, vdrMediaGroupLoading]);



  let uniqueData = [];
  if (CompanyVideosArr.length >= 0) {
    const unique = [...new Map(CompanyVideosArr.map(item => [item['CompanyID'], item])).values()]; // [ 'A', 'B'] 
    uniqueData = unique;
  }
const filteredData = (gId) => {
  // console.log(VideosArr); 
  // return VideosArr;
  return VideosArr.filter((item0)=>{ if(item0.groupId == gId) return item0 } ).sort((a,b)=>{ return a.item_order - b.item_order })
}
  // console.log(companyMasterData);

  return (
    <>
      <Box className="headerContainerFront">
        <Typography
          style={{ zIndex: 2 }}
          fontSize={"2.5em"}
          color="#C2A560"
          fontWeight="700"
        >
          Videos
        </Typography>
      </Box>

      <Box className="bodyContainer" sx={{
        marginTop: 5, marginBottom: 5

      }}>

            { PinnedVideoArr.length > 0
              && (
                <Box sx={{
              margin: '20px 0'
            }} id={`container00`}>
            {console.log(PinnedVideoArr)}
              <Box
                sx={{
                  display: 'flex',
                  padding: '0'
                }}
                justifyContent="space-between"
                alignItems={'center'}
              >
                <Typography variant="h6" >
                  Pinned
                </Typography>
              </Box>

                <Grid container spacing={1} className="demo-data-row" >
                { PinnedVideoArr && 
                  PinnedVideoArr.map((vidItem, i)=>{
                    {/* setVideoIds({...VideoIds, [i]: vidItem.videoId}) */}
                    return(
                    <Box style={{ aspectRatio: '16 / 9' }} className="demo-data" >
                        <SingleVideoGrid vidStyle={{ minHeight:'50vh' }} itemData={vidItem} />
                    </Box>
                  )
                  })
                }
                </Grid>

            </Box>
              )
            }
            

        {
          VideoGroupData && VideoGroupData.length > 0 && VideoGroupData.map((item, index) => {
            if(filteredData(item.group_id).length == 0){
              return 
            }
          return (
            
            <Box sx={{
              margin: '20px 0'
            }} id={`container00`}>
              <Box
                sx={{
                  display: 'flex',
                  padding: '0'
                }}
                justifyContent="space-between"
                alignItems={'center'}
              >
                <Typography variant="h6" >
                  {item.group_name}
                </Typography>
              </Box>

                <Grid container spacing={1} className="demo-data-row" >
                {
                   filteredData(item.group_id).map((vidItem, i)=>{
                     if(!VideoIds.includes(vidItem.videoId)){
                       return(
                         <Box style={{ aspectRatio: '16 / 9' }} className="demo-data" >
                           <SingleVideoGrid vidStyle={{ minHeight:'50vh' }} itemData={vidItem} />
                         </Box>
                       )
                     }
                   })
                }
                </Grid>

              {/* <CustomCarousel itemType="video" listingData={VideosArr} /> */}

            </Box>
          )
          })
        }

        {/* {
          uniqueData && uniqueData.length > 0 && uniqueData.map((item, index) => {
            const crtComp = CompanyVideosArr.filter((items) => { if (items.CompanyID === item.CompanyID) return items });
            let companyName = CompanyMasterArr.filter((items0) => { if (items0.CompanyID == item.CompanyID) return items0 });
            companyName = companyName[0]?.CompanyName;
            return ( 
              <>
                <Box sx={{
                  margin: '20px 0'
                }} id={`container00`}>
                  <Box
                    sx={{
                      display: 'flex',
                      padding: '0 0.8rem'
                    }}
                    justifyContent="space-between"
                    alignItems={'center'}
                  >
                    <Typography variant="h6">
                      {companyName}
                    </Typography>
                  </Box>
                  <CustomCarousel itemType="video" listingData={crtComp} />
                </Box>
              </>
            )
           })
        } */}


        <MediaModel />
      </Box>
    </>


  )
}

export default VideosPage